import React from 'react';
import { FadeIn } from './FadeIn';
import { Sun } from 'lucide-react';
export function Proof() {
  return <section className="bg-lavender py-24 px-6 md:px-12 relative overflow-hidden" data-id="element-117">
      <div className="max-w-4xl mx-auto text-center" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="flex justify-center mb-6" data-id="element-120">
            <Sun className="w-10 h-10 text-amber" data-id="element-121" />
          </div>
          <h2 className="text-4xl md:text-5xl mb-12" data-id="element-122">
            Lo que cambia en 7 días
          </h2>
        </FadeIn>

        <div className="space-y-8 text-xl md:text-2xl font-medium text-brown/80" data-id="element-123">
          <FadeIn delay={0.1} data-id="element-124">
            <p className="bg-white/60 p-6 rounded-2xl shadow-sm" data-id="element-125">
              La bruma mental desaparece. Dejás de "sobrevivir" al día y empezás
              a estar presente.
            </p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-126">
            <p className="bg-white/60 p-6 rounded-2xl shadow-sm" data-id="element-127">
              Tu bebé se despierta de mejor humor porque su cerebro finalmente
              completó los ciclos de sueño reparador que necesitaba.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}